import ApiClient from './ApiClient';

class EmailCampaignSendersAPI extends ApiClient {
  constructor() {
    super('email_campaign_senders', { accountScoped: true });
  }
}

export default new EmailCampaignSendersAPI();
